import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as ArrowIcon } from "../../../assets/icons/arrow-down-dropdown.svg";
import { ReactComponent as CheckIcon } from "../../../assets/icons/Checkbox.svg";
import {
  STUDENT_STATUS_FILTER_ACTION_TYPE,
  TEACHER_STATUS_FILTER_ACTION_TYPE,
  LESSON_TABLE_ALL_ACTIONS_TYPE,
  FILTER_ACTION_TYPE,
} from "../../../redux/actions-type";
import { useCustomHook } from "../../GlobalFunctions/globalFunctions";

export const CategoryDropdown = ({ statusType, deviceType = "" }) => {
  const dispatch = useDispatch();
  const { notificationCategoriesList } = useCustomHook();
  const { category } = useSelector((state) => state.filter);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const selectedCategory =
    notificationCategoriesList.find((item) => item.key === category)?.name ||
    "";

  const handleClick = (item) => {
    dispatch({
      type: FILTER_ACTION_TYPE.GET_FILTER_DATA,
      payload: { category: item.key },
    });
  };

  return (
    <div
      className={`global-category-dropdown dropdown-name data-status ${deviceType} ${
        dropdownOpen ? "active" : ""
      }`}
    >
      <div
        className="dropdown-head"
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <h2>{selectedCategory}</h2>
        <div className="arrow-icon">
          <ArrowIcon />
        </div>
      </div>

      <div className="dropdown-body">
        <ul>
          {notificationCategoriesList.map((item) => (
            <li key={item.key} onClick={() => handleClick(item)}>
              {item.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
